// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1J0+m","main-image":"Header_main-image__U2Quv","stroke":"Header_stroke__pauXQ"};